import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 40
  },
  whileInView: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  },
  viewport: {
    once: true,
    margin: '-100px'
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  whileInView: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  },
  viewport: {
    once: true,
    margin: '-50px'
  }
};
export function ProblemSection() {
  const failedMethods = ['Los abanicos solo mueven el mismo aire caliente y anuncian a todo el mundo que estás teniendo un síntoma.', 'Los suplementos naturales pueden tardar meses en hacer efecto (si es que lo hacen).', 'Beber agua helada ayuda, pero no siempre tienes un vaso a mano en el segundo exacto del impacto.', 'Intentar "aguantar" solo eleva tu cortisol, empeorando la sudoración y la ansiedad social.'];
  return <>
      {/* Opening Hook */}
      <section className="bg-brand-cream py-24 px-6" data-id="element-114">
        <motion.div initial="hidden" whileInView="whileInView" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeInUp} className="max-w-3xl mx-auto text-center" data-id="element-115">
          <p className="font-serif italic text-2xl md:text-3xl text-brand-charcoal leading-relaxed" data-id="element-116">
            "Estás en medio de una reunión importante o en una cena que
            planeaste durante semanas. De repente, sientes esa chispa familiar
            en el pecho. El calor sube por tu cuello como un incendio forestal.
            El pánico se instala: '¿Se me nota la cara roja?', '¿Tengo sudor en
            el labio?'. <br data-id="element-117" />
            <br data-id="element-118" />
            Intentas concentrarte, pero tu cerebro solo grita una cosa:{' '}
            <span className="font-bold not-italic text-brand-coral" data-id="element-119">
              ¡Sácame de aquí!
            </span>
            "
          </p>
        </motion.div>
      </section>

      {/* The Problem */}
      <section className="bg-brand-sage py-24 px-6" data-id="element-120">
        <motion.div initial="hidden" whileInView="whileInView" viewport={{
        once: true
      }} variants={fadeInUp} className="max-w-4xl mx-auto" data-id="element-121">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-teal mb-8 text-center" data-id="element-122">
            No es solo "sentir calor"
          </h2>
          <div className="space-y-6 font-sans text-lg text-brand-charcoal/90 leading-relaxed" data-id="element-123">
            <p data-id="element-124">
              Para una mujer activa de más de 40 años, un sofoco no es solo
              "sentir calor". Es una interrupción brutal de tu confianza. Es el
              miedo a perder la compostura en el trabajo, la incomodidad de
              mojar tu blusa de seda favorita y la frustración de sentir que tu
              cuerpo te está traicionando en el peor momento posible.
            </p>
            <p data-id="element-125">
              Lo peor es que el estrés de "querer ocultarlo" dispara la
              adrenalina, lo que hace que el sofoco sea más intenso y dure mucho
              más. Es un círculo vicioso que parece no tener fin.
            </p>
          </div>
        </motion.div>
      </section>

      {/* What Didn't Work */}
      <section className="bg-brand-cream py-24 px-6" data-id="element-126">
        <div className="max-w-5xl mx-auto" data-id="element-127">
          <motion.h2 initial="hidden" whileInView="whileInView" viewport={{
          once: true
        }} variants={fadeInUp} className="font-serif text-3xl md:text-4xl font-bold text-brand-charcoal mb-12 text-center" data-id="element-128">
            Por qué lo que has intentado no funciona
          </motion.h2>

          <motion.div variants={staggerContainer} initial="hidden" whileInView="whileInView" className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-129">
            {failedMethods.map((method, index) => <motion.div key={index} variants={fadeInUp} className="bg-white p-8 rounded-2xl shadow-sm border border-brand-sage/50 flex items-start gap-4" data-id="element-130">
                <XCircle className="w-6 h-6 text-brand-coral shrink-0 mt-1" data-id="element-131" />
                <p className="font-sans text-brand-charcoal/80 leading-relaxed" data-id="element-132">
                  {method}
                </p>
              </motion.div>)}
          </motion.div>
        </div>
      </section>
    </>;
}